import { useRef, useState } from "react";
import loaderContext from "./LoaderContext";

const LoaderState = (props) => {
  const ref = useRef(null);
  const refAnnotation = useRef(null);
  const [loaderRunning, setLoaderRunning] = useState(false);
  const [loaderAnnotationRunning, setLoaderAnnotationRunning] = useState(false);
  const [enableButtonTourPurpose,setEnableButtonTourPurpose] = useState({
    showHeader:false,
    showFilterPopup: false,
  });

  const [showModal, setShowModal] = useState(
    {show:false, 
    type: null,
    isError: false,
    isWarning: false,
    isSuccess: false,
    appFailer: false,
    heading: "",
    description: "",
  });

  const hideAlertModal = () => {
    setShowModal(
      {show:false, 
      type: null,
      isError: false,
      isWarning: false,
      isSuccess: false,
      appFailer: false,
      heading: "",
      description: "",
    });
  }

  return (
    <loaderContext.Provider
      value={{
        ref,
        refAnnotation,
        setLoaderRunning,
        loaderRunning,
        loaderAnnotationRunning,
        setLoaderAnnotationRunning,
        showModal, setShowModal,
        hideAlertModal,
        enableButtonTourPurpose,setEnableButtonTourPurpose
      }}
    >
      {props.children}
    </loaderContext.Provider>
  );
};

export default LoaderState;
